import { useCallback, useRef, useState } from 'react'
import { useDebouncedCallback } from '@shared/lib/hooks/useDebouncedCallback'
import { LightGQL } from '@shared/api/gql-service/LightGQLService'
import { MAPPING_API_GQL } from '@shared/api/middleware/mappingAPI'
import { GQL_TAGS } from '@shared/api/api.gql'

// эта штука должна быть сгенерирована, но пока схаваем и так

export interface useQuickSearch_search_v2_items_Place {
  __typename: 'Place'
  id: string
  name: string
  url: string
  address: string | null
  afishaChoice: boolean
  rating: number | null
  /**
   * Главный город
   */
  city: useQuickSearch_search_v2_items_Place_city | null
  features: useQuickSearch_search_v2_items_Place_features[]
}
export interface useQuickSearch_search_v2_items_Place_city {
  id: string
  prepositionalName: string
}

export interface useQuickSearch_search_v2_items_Place_features {
  reservationUrl: string | null
  mainTag: {
    name: string | null
  } | null
}

export interface useQuickSearch_search_v2_items_Article {
  __typename: 'Article'
  id: string
  name: string
  url: string
  publicationDate: Date | string
}

export type QuickSearchItemType = useQuickSearch_search_v2_items_Place | useQuickSearch_search_v2_items_Article

// тонкая половица ада

type State = {
  results: QuickSearchItemType[]
  isLoading: boolean
  isError: boolean
}

export const useQuickSearch = () => {
  const [state, setState] = useState<State>({
    isLoading: false,
    isError: false,
    results: [],
  })

  const abortControllerRef = useRef<AbortController | null>(null)

  const abort = useCallback(() => {
    if (abortControllerRef.current?.signal.aborted === false) {
      abortControllerRef.current.abort()

      abortControllerRef.current = new AbortController()
    }
  }, [])

  const load = useDebouncedCallback(
    async (value: string) =>
      LightGQL.afisha
        .query(GQL_TAGS.QUICK_SEARCH, {
          variables: {
            query: `searchText=${value}&tab=Restaurant&searchInAllCities=true&pageSize=24`,
            offset: 0,
            first: 24,
            text: value,
          },
          mapping: MAPPING_API_GQL.quickSearch,
          requestInit: { signal: (abortControllerRef.current = new AbortController()).signal },
        })
        .then((relevantData) => {
          setState((oldS) => ({ ...oldS, results: relevantData || [], isError: false, isLoading: false }))
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            return
          }

          console.error(error.message)
          setState((oldS) => ({ ...oldS, isError: true }))
        }),
    200,
  )

  const tryQuickSearch = useCallback((text: string) => {
    const sanitizedText = text.trim()

    abort()

    if (sanitizedText) {
      setState((oldS) => ({ ...oldS, isLoading: true }))

      load(sanitizedText)
    } else {
      setState((oldS) => ({ ...oldS, results: [] }))
    }
  }, [])

  return [state.results, state.isLoading, { tryQuickSearch, isError: state.isError }] as const
}
